// extracted by mini-css-extract-plugin
export default {"active":"index_active__jHEIM"};